import { render } from "./viewPostedForm.vue?vue&type=template&id=a424bc68&scoped=true"
import script from "./viewPostedForm.vue?vue&type=script&lang=js"
export * from "./viewPostedForm.vue?vue&type=script&lang=js"

import "./viewPostedForm.vue?vue&type=style&index=0&id=a424bc68&scoped=true&lang=css"

import exportComponent from "/home/hakii/application-form-proto-admin-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a424bc68"]])

export default __exports__